export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const SET_USER_IMAGE = 'SET_USER_IMAGE';
export const SET_USER_THEME = 'SET_USER_THEME';
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';
export const SET_SOUND_NOTIFICATION = 'SET_SOUND_NOTIFICATION';
